import * as React from 'react';
import { Link } from 'react-router';
import { Button } from '@/semantic-ui/components';
import style from '@/less/main.less';

interface Props {
  link?: string;
  disabled?: boolean;
  onClick: () => void;
  saveText?: string;
  hideSave?: boolean;
  hideCancel?: boolean;
  cancelText?: string;
  onCancel?: () => void;
  saveButtonColor?: string;
  cancelButtonColor?: string;
}

const SaveButtons: React.FC<Props> = ({
  link,
  disabled,
  onClick,
  hideSave,
  hideCancel,
  saveText = 'Save',
  cancelText = 'Cancel',
  onCancel,
  saveButtonColor = '#D7AB73',
  cancelButtonColor = 'grey',
}) => {
  const cancelButton = onCancel && !hideCancel && (
    <Button
      type="button"
      className={style.confirm_button}
      style={{ color: '#fff', backgroundColor: cancelButtonColor }}
      onClick={onCancel}
    >
      {cancelText}
    </Button>
  );

  return (
    <div className={style.confirm_wrapper}>
      {link && <Link to={link}>{cancelButton}</Link>}
      {!link && cancelButton}
      {!hideSave && (
        <Button
          type="submit"
          onClick={onClick}
          className={style.confirm_button}
          style={{ color: '#fff', backgroundColor: saveButtonColor }}
          disabled={disabled}
        >
          {saveText}
        </Button>
      )}
    </div>
  );
};

SaveButtons.defaultProps = {
  disabled: false,
  link: undefined,
};

export default SaveButtons;
